<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            showTomorrow
            twoMonthLimit
          ></tg-date-search>
          <tg-dropdown :items="dropdown" @on-change="handleChange" trigger="click">
          </tg-dropdown>
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.targetName"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row type="flex" v-show="hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleExport"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.export") }}
          </tg-button>
        </el-row>
      </el-row>
      <tg-amount-bar
        ref="amount"
        v-if="showAmount"
        :columns="amountColumns"
        :row="amountTotalData"
        :mouseTouch="false"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @on-loaded="handleLoaded"
      showSummary
      :summary-method="parsePageSummary"
      showPagination
    >

    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";
import TgAmountBar from "@/components/amount/TgAmountBar";

import { convertToRows, flatColumns } from "@/utils/table";
import { summary } from "@/utils/table";
// import str from "@/utils/str";
import xlsx from "@/utils/xlsx";


import apis from "@/apis";

const api = apis.accounts.return_bonus;
export default {
    components: {
        TgLayout,
        TgDateSearch,
        TgDropdown,
        TgSearchTool,
        TgButton,
        TgAmountBar
    },
    data() {
        return {
            columns: [],
            amountColumns: [],
            proxy: api.getData,
            dateRange: {},
            group: [80, 70, 60, 40, 20, 10], // 帳號層級
            dropdown:[],
            searchData: {
                userType:80,
            },
            showAmount: false,
            hasData: false,
            amountTotalData:[],
            amountPageData: [],
        };
    },
    computed: {
        headerHeight() {
            return !this.showAmount ? 120 : 160;
        },
        request() {
            return { ...this.searchData, ...this.dateRange };
        },
        dateString() {
            return new Date().toISOString().replace(/[-:.]/g, "");
        },
        parsePageSummary() {
            let data = this.amountPageData ? [this.amountPageData] : [];
          
            return () => {
                return summary(
                    this.columns,
                    data,
                    this.$t("component.table.summary"),
                    0
                );
            };
        },
    },
    created() {
        this.group.forEach(content => {
            this.dropdown.push({
                label: this.$t("column.l" + content),
                value: content,
            });
        });

        api.getColumns().then((response) => {
            this.columns = response.data;
            this.amountColumns = response.data.filter((c) => {
              return 'amount_bar' in c && c.amount_bar;
            });
        });
        this.$nextTick(() => {
            this.$refs.table.init(this.request);
        });
    },
    methods: {
        // 查詢
        handleSearch() {
            this.$nextTick(() => {
                this.$refs.table.search(this.request);
            });
        },
        handleChange(item) {
            this.searchData.userType = item.value;
        },
        // 處理response
        handleLoaded(response) {
            if (response.retcode == 0) {
                this.hasData = response.data.length > 0;
                this.showAmount = response.data.length > 0;

                let columns = JSON.parse(JSON.stringify(this.columns));
                
                this.columns = columns;

                this.amountTotalData = response.amount_total;
                this.amountPageData = response.amount_page;
            }
        },
        handleExport() {
            let exportFileName = this.$t('component.export.return_bonus_statement');
            let request = { ...this.request, isExport: true };
            api.getExport(request).then((response) => {
                let data = response.data;
                let headerRow = convertToRows(response.columns);
                let columns = flatColumns(response.columns);
                let ws = xlsx.makeSheet(
                    headerRow,
                    columns,
                    data,
                    response.amount_total
                );
                xlsx.exportExcel(ws, exportFileName + "-" + this.dateString);
            });

            this.$store.commit("breadcrumb/add", {
                name: this.$route.name,
                id: this.$route.name + "_" + this.row.name,
                meta: {
                    title: this.row.name,
                },
            });
        },
    },
};
</script>
